


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Pdi, VehicleLocation } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { ValidationRules } from '@/helper/enum';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    }
})
export default class EditPayrocTerminalPage extends Base {
    public storeViewModel: any = {};
    public storeModel: StoreModel = {};

    public terminalModel: any = {};
    public selectedLocation: string = '';
    public form: any = {};
    public payrocUpdateTerminalFields: Array<VFields<any>> = [];
    public storeId: number = 0;
    public serialNumber: string = '';
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public requestProgress: boolean = false;

    public callMethod(methodName): void {
        if (methodName === 'backToStoreEdit') {
            this.$router
                .push({
                    name: 'admin.stores.edit',
                    params: { id: this.storeId.toString(), tab: 'PayrocAccount' },
                })
                .catch((ex) => {
                    console.log(ex);
                });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(
                    false,
                    this.$t('stores.vehicleLocations.alertInvalidForm')
                );
                this.resetMethodName(methodName);
                return;
            }
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        if (this.storeId) {
            buttons.push({
                id: '0',
                type: 'button',
                title: this.$parent.$t('stores.btnBackToStoreTitle'),
                disabled: false,
                visible: true,
                class: 'btn',
                label: this.$parent.$t('stores.btnBack'),
                click: 'backToStoreEdit',
                icon: 'fas fa-arrow-left',
            });
        }
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        this.setLocationFields();
        if (this.$route.params.storeId) {
            this.storeId = Number(this.$route.params.storeId);
            this.serialNumber = this.$route.params.payrocSerialNumber;
            this.getStoreInfo();
        }

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
    }

    public setLocationFields(): void {
        this.payrocUpdateTerminalFields = [
            {
                key: 'serialNumber',
                required: false,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: true,
                    required: false,
                    label: 'Serial Number',
                    counter: 80,
                    loading: false,
                    rules: [
                        v => this.required('Serial Number', v)
                    ]
                },
            },
            {
                key: 'processingTerminalId',
                required: true,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Processing TerminalId',
                    counter: 80,
                    loading: false,
                    rules: [
                        v => this.required('Processing TerminalId', v)
                    ]
                },
            },
            {
                key: 'deviceName',
                required: true,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Device Friendly Name',
                    counter: 80,
                    loading: false,
                    rules: [
                        v => this.required('Device Friendly Name', v)
                    ]
                },
            },
        ];
    }

    public validateDeviceName(): Vue & { validate: () => boolean } {
        return this.$refs.payrocUpdateTerminalForm as Vue & { validate: () => boolean };
    }

    public async updatePayrocAddTerminal(): Promise<void> {
        if (this.validateDeviceName().validate()) {
            try {
                this.requestProgress = true;
                this.$emit('update:progress', this.requestProgress);
                const res = await storeService.updatePayrocTerminalSetup(
                    this.terminalModel.serialNumber,
                    this.terminalModel.deviceName,
                    this.terminalModel.processingTerminalId,
                    this.storeId
                );
                if (res.status) {
                    this.showAlert(true, "Selected terminal details have been updated successfully");
                    this.$router
                        .push({
                            name: 'admin.stores.edit',
                            params: {
                                tenantId: this.tenantId.toString(),
                                enterpriseId: this.enterpriseId.toString(),
                                storeId: this.storeId.toString(),
                                tab: 'PayrocAccount'
                            },
                        });
                }
            } finally {
                this.requestProgress = false;
                this.$emit('update:progress', this.requestProgress);
            }
        }
    }

    public async getStoreInfo(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.payrocUpdateTerminalFields);
            const response = await storeService.getStore(this.storeId);
            this.storeViewModel = response;
            this.storeModel.id = this.storeViewModel.id;
            const payrocLaneJson = [];
            this.terminalModel = response.payrocLaneJson.filter(
                (x) => x.serialNumber == this.serialNumber
            )[0];
        } finally {
            this.formlyHideSkeleton(this.payrocUpdateTerminalFields);
        }
    }
}
